<template>
  <div class="index">
    <div class="card">
      <div class="avatar">
        <img v-lazy="data.deviceimage">
      </div>
      <div class="right">
        <div class="f">{{data.devicename}}</div>
        <div class="b">
          <div class="s">
            <span>{{$t(langKey+'.desc1')}}</span>{{data.devicesn}}
          </div>
          <div class="t">
            <span>{{$t(langKey+'.desc2')}}</span>{{data.devicemodel}}
          </div>
        </div>
      </div>
    </div>
    <div class="nav">
      <div>
        <div class="row1">
          <router-link tag="div" to="./specification">
            <div class="icon sysm"></div>
          </router-link>
          <!--<router-link tag="div" to="./manual">-->
            <!--<div class="icon czsc"></div>-->
          <!--</router-link>-->
          <router-link tag="div" to="./quick-start">
            <div class="icon ksrm"></div>
          </router-link>
          <router-link tag="div" to="./ass-policy">
            <div class="icon shfw"></div>
          </router-link>
        </div>
        <div class="row2">
          <router-link tag="div" to="./specification">
            <div class="t">{{$t(langKey+'.item1')}}</div>
          </router-link>
          <!--<router-link tag="div" to="./manual">-->
            <!--<div class="t">{{$t(langKey+'.item2')}}</div>-->
          <!--</router-link>-->
          <router-link tag="div" to="./quick-start">
            <div class="t">{{$t(langKey+'.item3')}}</div>
          </router-link>
          <router-link tag="div" to="./ass-policy">
            <div class="t">{{$t(langKey+'.item4')}}</div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="items">
      <router-link tag="div" to="./suggestion" class="item">
        <div class="left">{{$t(langKey+'.item5')}} <span class="tips" v-if="lang==='zh'"></span></div>
        <div class="right">{{$t(langKey+'.desc3')}} <i class="iconfont icon-right"></i></div>
      </router-link>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { setTitle } from 'components/mixin/title'
import { mapGetters } from 'vuex'
export default {
  props: ['data'],
  data() {
    return {
      langKey: this.$route.name
    }
  },
  computed: {
    ...mapGetters(['lang'])
  },
  mixins: [setTitle],
  watch: {
    data(nv) {
      console.log(nv)
    }
  }
}
</script>
<style scoped lang="scss">
  @import "css/def";
  .index{
    min-height: 100vh;
    background:rgba(241,241,241,1);
    >.card{
      width: 100%;
      background-color: #fff;
      height: size(244);
      @include flex();
      @include border('bottom');
      align-items: flex-start;
      padding: size(32);
      .avatar{
        width: size(180);
        height: size(180);
        img{
          width: 100%;
          height: 100%;
          -webkit-border-radius: size(6);
          -moz-border-radius: size(6);
          border-radius: size(6);
        }
      }
      .right{
        width: calc(100% - #{size(180)});
        padding-left: size(32);
        height: 100%;
        position: relative;
        .f{
          width: 100%;
          font-size: size(30);
          font-weight:600;
          color:rgba(51,51,51,1);
          @include txt-overflow(2);
          line-height: 1.3;
        }
        .b{
          width: 100%;
          position: absolute;
          bottom: 0;
          left: size(32);
          font-size: size(26);
          color: rgba(153,153,153,1);
          span{
            display: inline-block;
            margin-right: size(18);
          }
          .t{
            margin-top: size(14);
            span{
              height: size(36);
              line-height: size(36);
              font-size: size(24);
              background: #FCEEE9;
              border-radius: size(2);
              color: #E8541E;
              padding: 0 size(16);
            }
          }
        }
      }
    }
    >.nav{
      width: 100%;
      height: size(244);
      background-color: #fff;
      padding: 0 size(20);
      @include flex();
      >div{
        width: 100%;
        >div{
          @include flex();
          &.row2{
            align-items: flex-start;
          }
          >div{
            width: 33.3333%;
            text-align: center;
            font-size: size(24);
            color: #333;
            .icon{
              display: inline-block;
              width: size(64);
              height: size(64);
              -webkit-background-size: 100% 100%;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              &.sysm{
                background-image: url('~image/icon/sysm.png');
              }
              &.czsc{
                background-image: url('~image/icon/czsc.png');
              }
              &.shfw{
                background-image: url('~image/icon/shfw.png');
              }
              &.ksrm{
                background-image: url('~image/icon/ksrm.png');
              }
            }
            .t{
              margin-top: size(22);
              font-weight: 600;
            }
          }
        }
      }
    }
    >.items{
      margin-top: size(20);
      background-color: #fff;
      width: 100%;
      padding: 0 size(28);
      >.item{
        height: size(112);
        width: 100%;
        @include flex();
        justify-content: space-between;
        .left{
          font-weight: 600;
          font-size: size(30);
          color: #333;
          .tips{
            display: inline-block;
            width: size(80);
            height: size(30);
            -webkit-background-size: 100% 100%;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-image: url('~image/icon/qp.png');
            position: relative;
            left: size(10);
            top: size(-16);
          }
        }
        .right{
          color: #999;
          font-size: size(26);
          text-align: right;
          position: relative;
          padding-right: size(32);
          i{
            font-size: size(32);
            position: absolute;
            top: 50%;
            right: 0;
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/equipment/index.vue